import { IsRoot } from '@capgo/capacitor-is-root';

export const useCapacitorRootDetection = () => {
  const checkRootStatus = async (): Promise<boolean> => {
    const { result } = await IsRoot.isRooted();
    return result;
  };

  return { checkRootStatus };
};
